export default class RequiredInputService {
    initRequiredInputsValidation() {
        const rawInputs = document.querySelectorAll('.perla-form .input-text.wpcf7-validates-as-required, .perla-form .input-text[required]');
        const inputs = [...new Set(rawInputs)];
        inputs.forEach((input) => {
            if (!input) {
                return;
            }
            const onUserInput = () => {
                var _a;
                const inputContainer = input.closest('.input-container');
                if (!inputContainer) {
                    return;
                }
                const isEmpty = !((_a = input.value) !== null && _a !== void 0 ? _a : '').trim();
                if (isEmpty) {
                    inputContainer.classList.add('error');
                }
                else {
                    inputContainer.classList.remove('error');
                }
            };
            input === null || input === void 0 ? void 0 : input.addEventListener('blur', onUserInput);
            input === null || input === void 0 ? void 0 : input.addEventListener('input', onUserInput);
        });
    }
    init() {
        this.initRequiredInputsValidation();
    }
}
